module.exports = __webpack_public_path__ + "media/img/calendar/arrow-right-1f8b399e2c611c04af32b29457af8ef4.png";